import { action } from 'satcheljs';
export var startDomainEnroll = action('startDomainEnroll');
//# sourceMappingURL=startDomainEnroll.js.map